module.exports = {
	"conditions": [
		{
			"id": "condition1",
			"code": "195967001",
			"system": "http://snomed.info/sct",
			"name": "Asthma",
			"status": "NA"
		},
		{
			"id": "condition2",
			"code": "73211009",
			"system": "http://snomed.info/sct",
			"name": "Diabetes mellitus",
			"status": "NA"
		},
		{
			"id": "condition3",
			"code": "38341003",
			"system": "http://snomed.info/sct",
			"name": "High Blood Pressure",
			"status": "NA"
		},
		{
			"id": "condition4",
			"code": "13644009",
			"system": "http://snomed.info/sct",
			"name": "High Cholesterol",
			"status": "NA"
		},
		{
			"id": "condition5",
			"code": "22298006",
			"system": "http://snomed.info/sct",
			"name": "Heart Attack",
			"status": "NA"
		}
	],
	"allergies": [
		{
			"id": "allergy1",
			"name": "Peanuts",
			"status": "NA"
		},
		{
			"id": "allergy2",
			"name": "Aspirin",
			"status": "NA"
		},
		{
			"id": "allergy3",
			"name": "Penicillin",
			"status": "NA"
		},
		{
			"id": "allergy4",
			"name": "Gluten",
			"status": "NA"
		},
		{
			"id": "allergy5",
			"name": "Dairy products",
			"status": "NA"
		},
		{
			"id": "allergy6",
			"name": "Morphine",
			"status": "NA"
		}
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/json-loader!./src/www/resources/patient-form-portal-response.json
 ** module id = 832
 ** module chunks = 0
 **/